
import { Question, AssessmentDimension } from "../types/assessment";
import { strategyQuestions } from "./categories/strategy";
import { dataQuestions } from "./categories/data";
import { talentQuestions } from "./categories/talent";
import { deploymentQuestions } from "./categories/deployment";
import { innovationQuestions } from "./categories/innovation";

export const questions: Question[] = [
  ...strategyQuestions,
  ...dataQuestions,
  ...talentQuestions,
  ...deploymentQuestions,
  ...innovationQuestions
];

export const categories = [
  {
    id: "strategy",
    title: "Category A: AI Strategy & Leadership",
    description: "This category evaluates how AI is integrated into an organization's strategy, leadership support, and vision."
  },
  {
    id: "data",
    title: "Category B: Data & Infrastructure",
    description: "This category assesses data governance, AI infrastructure readiness, and security."
  },
  {
    id: "talent",
    title: "Category C: Talent & Skills",
    description: "This category evaluates the organization's AI talent pool and skills development."
  },
  {
    id: "deployment",
    title: "Category D: AI Use Case Deployment & ROI",
    description: "This category assesses the implementation and value generation of AI initiatives."
  },
  {
    id: "innovation",
    title: "Category E: Innovation & Ecosystem Collaboration",
    description: "This category evaluates the organization's involvement in the broader AI ecosystem."
  }
];

export const getDimensionDescription = (dimension: AssessmentDimension): string => {
  const category = categories.find(cat => cat.id === dimension);
  return category?.description || "";
};

// More detailed descriptions for each dimension - used as fallbacks if no question-specific tooltip is defined
export const detailedDimensionDescriptions: Record<AssessmentDimension, string> = {
  strategy: "Examines leadership commitment, strategic planning, governance structures, and ethical frameworks for AI adoption. This dimension evaluates how well AI initiatives align with business objectives.",
  
  data: "Evaluates data quality, accessibility, governance, and infrastructure readiness for AI applications. This includes security measures, privacy controls, and the organization's ability to leverage data assets effectively.",
  
  talent: "Assesses the organization's AI capabilities through its people - including specialized AI roles, training programs, knowledge sharing, and collaboration between technical and business teams.",
  
  deployment: "Measures the organization's ability to implement AI solutions effectively, track ROI, manage risks, maintain systems, and scale successful initiatives across the enterprise. This includes monitoring, testing, and risk assessment processes.",
  
  innovation: "Evaluates the organization's AI research capabilities, experimentation approach, ecosystem partnerships, and overall contribution to AI advancement both internally and externally."
};
